<template>
  <div
    v-bind:class="{ selected: selected }"
    @click="onItemClick"
    class="autoCompleteListItem"
  >
    {{ item.description | locationName }}
  </div>
</template>

<script>
export default {
  name: 'SimulationContentDeliverySearchAutoCompleteListItem',
  filters: {
    locationName(description) {
      return description.replace(/日本、/, '')
    },
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onItemClick() {
      this.$emit('itemClick', this.item)
    },
  },
}
</script>

<style scoped lang="scss">
.autoCompleteListItem {
  cursor: pointer;
  padding: 2px 10px;
  font-size: 12px;
  transition: background-color 0.1s;
  &:hover {
    background: #c8dbff;
  }
  &.selected {
    background-color: #c8dbff;
  }
}
</style>
